import React from "react";
import {Link} from "react-router-dom";
import "./Work.css";
import projects from "../../Works/AllWork.json";
import SmallCard from "./SmallCard";

class Work extends React.Component {

    state = {
        isHovered: false
    }

    handleHover = () => {
        this.setState({isHovered: true});
    }

    handleLeave = () => {
        this.setState({isHovered: false});
    }

    render() {
        const bodyClass = this.state.isHovered
            ? "card-body-hover"
            : "card-body"
        const moreInfoClass = this.state.isHovered
            ? "more-info-hover"
            : "moreInfo"
        return (
            <div id="work-container">
                <div className="row">
                    <div className="col-md-12 sm-12 text-center mb-4">
                        <div>
                            <p id="workHeader">Our Work</p>
                            <p id="work-sub-header">Select a project to find out more, or view all of our work <a href="/work">here.</a>
                            </p>
                        </div>
                    </div>
                </div>
                <div className="row mt-5">
                    <div className="col-md-6 mb-3">
                        <a href={"/projectInfo/" + projects[0].projectId}>
                            <div
                                className="card mb-3"
                                onMouseEnter={this.handleHover}
                                onMouseLeave={this.handleLeave}>
                                <img
                                    className="work-card-img-top"
                                    src={projects[0].projectImage}
                                    alt="Card image cap"/>
                                <div className={bodyClass}>
                                    <div>
                                        <h5 className="card-title">{projects[0].projectName}</h5>
                                        <p className="card-text">{projects[0].projectDescription}</p>
                                        <p className="col text-center" href="/work" className={moreInfoClass}>{projects[0].projectMoreInfo}</p>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div className="col-md-6 mb-3">
                        <SmallCard/>
                    </div>
                </div>
            </div>
        );
    }

};

export default Work;



// WEBPACK FOOTER //
// ./src/components/Mainpage/Work/Work.js